// T-040 (Bug 2): aspect-locked scaling. This is the aspectRatioLocked=true path,
// so the natural proportion MUST be preserved end to end.
//
// The user drives one axis. We clamp the driver to its own maximum and derive
// the other axis from the ratio. If the derived axis overflows ITS maximum, we
// pin the derived axis to that maximum and RE-DERIVE the driver from it, so the
// ratio never breaks. The typed axis still responds (it is no longer frozen);
// it is simply capped by the limiting axis while proportion is kept.
//
// Pure + side-effect free so it can be unit-tested headless.
//
// @param {Object}  p
// @param {'width'|'height'} p.driver  which axis the user is editing
// @param {number}  p.value            the driven axis value (px, integer-ish)
// @param {number}  p.naturalWidth     intrinsic image width  (> 0)
// @param {number}  p.naturalHeight    intrinsic image height (> 0)
// @param {number}  p.maxWidth         MAX_CONTENT_WIDTH
// @param {number}  p.maxHeight        MAX_CONTENT_HEIGHT
// @returns {{ width: number, height: number }} integers, ratio preserved,
//          clamped so width<=maxWidth AND height<=maxHeight.
export function scaleWithAspect({
  driver,
  value,
  naturalWidth,
  naturalHeight,
  maxWidth,
  maxHeight,
}) {
  const ratioWH = naturalWidth / naturalHeight; // width per unit height

  let width;
  let height;
  if (driver === 'height') {
    // Clamp the driver to its own max, derive width. If width overflows, pin it
    // and RE-DERIVE height so the ratio is preserved (aspect is locked).
    height = Math.min(value, maxHeight);
    width = Math.round(height * ratioWH);
    if (width > maxWidth) {
      width = maxWidth;
      height = Math.round(maxWidth / ratioWH);
    }
  } else {
    // Symmetric for the width driver.
    width = Math.min(value, maxWidth);
    height = Math.round(width / ratioWH);
    if (height > maxHeight) {
      height = maxHeight;
      width = Math.round(maxHeight * ratioWH);
    }
  }

  return { width, height };
}

export default scaleWithAspect;
